<template>
    <div>
        <div class="row">
            <div class="col-12">
                <User v-if="tableData.length" :tableData="tableData" @deleteUserModal="dialogVisibleUserDelete = true; userToDelete.id = $event.id; showWarning = $event.showWarning" />
                <EmptyUser v-else-if="!this.$store.state.user.allUsers" />
                <NotFound v-else />
            </div>
        </div>
        <UserDelete :dialogVisible="dialogVisibleUserDelete" @closeModal="dialogVisibleUserDelete = $event" @deleteUser="userDeleteRequest" :showWarning="showWarning"/>
    </div>
</template>

<script>
import User from '@/components/tables/User'
import UserDelete from '@/components/modals/UserDelete'
import getAllUsers from '@/api/getAllUsers'
import deleteUserForReal from '@/api/deleteUserForReal'
import EmptyUser from '@/components/emptyOrNotFound/EmptyUser'
import NotFound from '@/components/emptyOrNotFound/NotFound'


export default {
    components: {
        User,
        UserDelete,
        EmptyUser,
        NotFound,
    },
    props: {
        tableData: {
            required: true
        },
    },
    data() {
        return {
            dialogVisibleUserDelete: false,
            userToDelete: {
                id: null
            },
            showWarning: false
        }
    },
    methods: {
        async userDeleteRequest() {
            if (this.userToDelete.id != null) {

                const result = await deleteUserForReal(this.userToDelete.id)

                if (result.data.ok) {
                    this.$notify({
                        title: 'Usuário excluido com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false
                    });
                    await getAllUsers({ page: 1 })
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.userToDelete.id = null
            this.dialogVisibleUserDelete = false
        },
    }
}
</script>

<style>
</style>
